var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsEnum, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { DictationPhase } from '../enums/dictation-phase.enum.js';
import { AiDocumentationActivationResponseDto } from './ai-documentation-activation-response.dto.js';
/**
 * The newest non-discarded dictation of one appointment and patient, as the
 * Dokumentations-Tab card needs it (Spec § 9): the phase for the chip, the
 * author for the label, `isOwn` for the button, `canReview` for opening the
 * review, `audioAvailable` for the regeneration modes offered later,
 * `latestDraftId` for the review.
 */
export class AiDocumentationOverviewDictationDto {
    id;
    phase;
    authorName;
    isOwn;
    /**
     * Whether the caller may open the review and save or drop its draft: the
     * author before the first save, the whole practice once the dictation is
     * `SAVED` (a post-save regeneration, S6).
     */
    canReview;
    audioAvailable;
    latestDraftId;
    updatedAt;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], AiDocumentationOverviewDictationDto.prototype, "id", void 0);
__decorate([
    Expose(),
    IsEnum(DictationPhase),
    __metadata("design:type", String)
], AiDocumentationOverviewDictationDto.prototype, "phase", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], AiDocumentationOverviewDictationDto.prototype, "authorName", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], AiDocumentationOverviewDictationDto.prototype, "isOwn", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], AiDocumentationOverviewDictationDto.prototype, "canReview", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], AiDocumentationOverviewDictationDto.prototype, "audioAvailable", void 0);
__decorate([
    Expose(),
    IsOptional(),
    IsUUID(),
    __metadata("design:type", Object)
], AiDocumentationOverviewDictationDto.prototype, "latestDraftId", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], AiDocumentationOverviewDictationDto.prototype, "updatedAt", void 0);
export class AiDocumentationOverviewAppointmentDto {
    appointmentId;
    /** Rule 3.2-1, evaluated server-side; the card shows the mic button only when true. */
    dictationAllowed;
    dictation;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], AiDocumentationOverviewAppointmentDto.prototype, "appointmentId", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], AiDocumentationOverviewAppointmentDto.prototype, "dictationAllowed", void 0);
__decorate([
    Expose(),
    IsOptional(),
    ValidateNested(),
    Type(() => AiDocumentationOverviewDictationDto),
    __metadata("design:type", Object)
], AiDocumentationOverviewAppointmentDto.prototype, "dictation", void 0);
/**
 * `GET /ai-documentation/patients/:patientId/overview` (Spec § 9): the
 * practice's activation state (for the banner) plus one row per appointment
 * of the patient, in the same order as the Dokumentations-Tab lists them.
 * Not behind the activation guard — the banner needs it before activation.
 */
export class AiDocumentationOverviewResponseDto {
    activation;
    appointments;
}
__decorate([
    Expose(),
    ValidateNested(),
    Type(() => AiDocumentationActivationResponseDto),
    __metadata("design:type", AiDocumentationActivationResponseDto)
], AiDocumentationOverviewResponseDto.prototype, "activation", void 0);
__decorate([
    Expose(),
    IsArray(),
    ValidateNested({ each: true }),
    Type(() => AiDocumentationOverviewAppointmentDto),
    __metadata("design:type", Array)
], AiDocumentationOverviewResponseDto.prototype, "appointments", void 0);
//# sourceMappingURL=ai-documentation-overview-response.dto.js.map